import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import SupportBody from './SupportBody';
import SubHeader from '../SubHeader';

import './SupportDashboard.css';

@inject('translationsStore')
@observer
export default class SupportDashboard extends Component {
  render() {
    const { translationsStore } = this.props;
    return (
      <div className="SupportDashboard">
        <SubHeader className="SupportSubHeader">
          <div style={{margin: '0px auto 50px auto', color: 'white', fontSize: 36}}>{ translationsStore.translate('support.dashboard.mayWeHelp') }</div>
        </SubHeader>
        <SupportBody />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/SupportDashboard/SupportDashboard.js